import { http } from '@/shared/api/client';
import type { PassbookQuotas, PixCharge, QuotaChannel } from '../model/ledger';

export interface PixChargeResponse {
  status: PixCharge['status'] | 'unavailable';
  code?: string;
  message: string;
  charge: PixCharge | null;
}

export function channelQuotaKey(passbookId: string) {
  return ['channel-quota', passbookId] as const;
}

export async function fetchPassbookQuotas(passbookId: string): Promise<PassbookQuotas> {
  return http.get<PassbookQuotas>(`/bff/billing/quota?passbookId=${encodeURIComponent(passbookId)}`);
}

export async function reserveChannelQuota(input: {
  passbookId: string;
  channel: QuotaChannel;
  slots: number;
}): Promise<PassbookQuotas> {
  return http.post<PassbookQuotas>('/bff/billing/consume', input);
}

export async function createPixCharge(input: {
  passbookId: string;
  channel: QuotaChannel;
  slots: number;
}): Promise<PixChargeResponse> {
  return http.post<PixChargeResponse>('/bff/billing/pix', input);
}

export async function fetchPixCharge(id: string): Promise<PixChargeResponse> {
  return http.get<PixChargeResponse>(`/bff/billing/pix/${encodeURIComponent(id)}`);
}
